import { buildColumnExpression } from "helpers/utils/build-column-expression";
import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import { IIdentifierFields, IUPCData, IUPCDataError, UPCRuleType } from "../types";

export class RequiredColumnsRule extends Validator<IUPCData[], IUPCDataError> {
    private readonly requiredColumns: Set<IIdentifierFields>;

    constructor(requiredColumns: IIdentifierFields[]) {
        super();
        this.requiredColumns = new Set([...requiredColumns]);
    }

    validate(model: IUPCData[], errors: IUPCDataError): IUPCDataError {
        const notEmptyErrorType = UPCRuleType.NotEmptyRule;
        const requiredColumnsErrorType = UPCRuleType.RequiredColumnsRule;
        const headers = Object.keys(model[0] || {});
        const missingColumns = new Set<string>();

        if (errors[notEmptyErrorType]) {
            return errors;
        }

        for (const column of this.requiredColumns) {
            const expression = buildColumnExpression(column.key);
            const foundHeader = headers.some((header) => expression.test(header));
            if (!foundHeader) {
                missingColumns.add(column.display_name);
            }
        }

        const hasMissingColumns = missingColumns.size > 0;

        const validationErrors = !hasMissingColumns
            ? errors
            : {
                  ...errors,
                  [requiredColumnsErrorType]: formatMessage(
                      "|fields| is a required field and is missing from your file.",
                      {
                          fields: Array.from(missingColumns).join(", "),
                      }
                  ),
              };

        return super.validate(model, validationErrors);
    }
}
